export const fuelTypes = [
  'Petrol',
  'Diesel',
  'Electric',
  'Hybrid',
  'Bi Fuel',
  'Hydrogen',
  'Natural Gas',
];
